export const isInvoiceFile = key => /^periodEnd\/\d+\/Invoices\/.*\.(pdf|png|jpg|tif|tiff)$/.test(key)
